<template>
    <button type="button" :class="buttonDef" @click="onClick">{{$t(title)}}
      <slot></slot>
    </button>
</template>
<script>
export default { 
  emits: ['onClick'],
  props: {
    title: {
      type: String,
      default: '',
      required: false
    },
    buttonClass: {
      type: String,
      default: '',
      required: false
    }
  },
  data() {
    return {
    };
  },
  methods: {
    onClick() {
      this.$emit('onClick');
    }
  },
  computed: {
    buttonDef() {
      return this.buttonClass === '' ? `my-button` : `${this.buttonClass}`;
    }    
  }
}
</script>

<style scoped>
.my-button {
    background: transparent;
    outline: none;
    border: none;
}

.my-button:hover {
}

</style>


// WEBPACK FOOTER //
// src/components/Button.vue